/**
 * Store data for Changes
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.ADD_CHANGE, this.__registerChange);
    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  /**
   * Get change by id
   * @param {number} changeId
   * @returns {Change}
   */
  getChange: function(changeId:number): Change {
    return this.__state[changeId];
  },

  /**
   * Handle DATA_LOADED event and populate/update change data from it.
   *
   * Async changes are expected to call DATA_LOADED with a top-level `changes` property, so that's what this is built
   * for.  DATA_LOADED is also produced with the client config upon initialization, but we don't expect to see a
   * top-level `changes` property in that case.  We have an alternate path for identifying changes from the client
   * config - look for the producers of the ADD_PREPARED_CHANGE event.
   *
   * @param {ClientData} payload.data
   * @private
   */
  __loadData: function(payload) {
    if (_.isEmpty(payload.data.changes)) {
      return;
    }
    _.each(payload.data.changes, _.bind(this.__registerChange, this));
  },

  /**
   * Register a single change, overwriting any existing change with the same id.
   * @param {Change} change
   * @private
   */
  __registerChange: function(change:Change) {
    if (__INVARIANT__) {
      require('../utils/invariant').isType('Change', change);
    }

    freeze.deepFreeze(change);
    this.__state[change.id] = change;
    this.emitChange();
  },
};
